var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticStyle:{"text-align":"center"},attrs:{"visible":_vm.visible,"append-to-body":true,"before-close":_vm.onClose},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('el-image',{attrs:{"src":_vm.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }